import { FC, useEffect, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { PageHeading, Sections, TeamHeading } from "@/components/Layout/Parts";
import LinksSection from "@/pages/LinksLibrary/components/LinksSection";
import { api } from "@/utils/api";
import { LibraryLinkResource } from "@/types/resources";
import useAlerts from "@/hooks/useAlerts";

const LinksLibrary: FC = () => {
  const alerts = useAlerts();

  const { data, isError } = useQuery<LibraryLinkResource[]>(
    ["library-links"],
    () => {
      return api.get<never, LibraryLinkResource[]>("/v1/library-links");
    },
    {
      staleTime: 2 * 60 * 1000,
    }
  );

  const tools = useMemo(
    () => data?.filter((link) => link.type === "tool"),
    [data]
  );

  const reports = useMemo(
    () => data?.filter((link) => link.type === "report"),
    [data]
  );

  useEffect(() => {
    if (isError) {
      alerts.error();
    }
  }, [isError, alerts]);

  return (
    <>
      <TeamHeading />
      <PageHeading>Links Library</PageHeading>
      <Sections $gapY={48}>
        <LinksSection heading="Tools" type="tool" links={tools} />
        <LinksSection heading="Reports" type="report" links={reports} />
      </Sections>
    </>
  );
};

export default LinksLibrary;
